import { apiClient } from './client.js'

export async function publishFloor(floorId, payload) {
  const { data } = await apiClient.post(`/floors/${floorId}/publish`, payload)
  return data
}

export async function fetchRecentPublishes(limit = 8) {
  const { data } = await apiClient.get('/publish/recent', { params: { limit } })
  return data.versions || []
}

export async function fetchPublishedRuntime(floorId) {
  const { data } = await apiClient.get(`/runtime/floors/${floorId}/published`, {
    headers: { 'X-ARROW-RUNTIME-TOKEN': import.meta.env.VITE_RUNTIME_TOKEN || '' },
  })
  return data
}
